import {AbstractService} from 'services/AbstractService';
import store from 'store/index';

const PROJECT_DASHBOARD_URL = 'api/projects/{0}/dashboard';
const PROJECT_WIDGETS_URL = 'api/projects/{0}/dashboard/widgets';
const PROJECT_PLAN_METRICS_URL = 'api/projects/{0}/dashboard/planmetrics';

const ACCESS_TYPES_URL = 'api/dashboards/access_types';
const DASHBOARD_DETAILS_URL = 'api/dashboards/{0}/dashboard';
const DASHBOARD_PLAN_METRICS_URL = 'api/dashboards/{0}/planmetrics';
const CREATE_USER_DASHBOARD_URL = 'api/dashboards/ofuser';

const USER_DASHBOARDS_LIST_URL = 'api/dashboards/ofuser';
const DASHBOARDS_LIST = 'api/dashboards';


export class DashboardService extends AbstractService {
  async getProjectDashboard (accountId, projectId) {
    const dashboardData = (await this.client.get(PROJECT_DASHBOARD_URL.format(projectId))).data;
    const allChannelsIds = store.getters['channels/channels'].map(x => x.id);

    /*
     * support lineChart with two metrics
     * change metric on metricsList
     * metricsList must always be an array
     */
    dashboardData.widgets = dashboardData.widgets.map(w => {

      // hard code for default dashboard
      if (!w[`${w.type}Values`].grouping && !w[`${w.type}Values`].channelIds && !w[`${w.type}Values`].filterEntities) {
        w[`${w.type}Values`].channelIds = allChannelsIds;
      }

      if (w.type === 'lineChart') {
        if (w[`${w.type}Values`].metricsList) {
          if (typeof w[`${w.type}Values`].metricsList === 'string') {
            w[`${w.type}Values`].metricsList = [w[`${w.type}Values`].metricsList];
          }
        } else if (w[`${w.type}Values`].metric) {
          if (typeof w[`${w.type}Values`].metric === 'string') {
            w[`${w.type}Values`].metricsList = [w[`${w.type}Values`].metric];
          } else {
            w[`${w.type}Values`].metricsList = w[`${w.type}Values`].metric;
          }
        }
        delete w[`${w.type}Values`].metric;
      }
      return w;
    });

    return dashboardData;
  }

  getProjectWidgetsList (accountId, projectId) {
    return this.client.get(PROJECT_WIDGETS_URL.format(projectId));
  }

  async getProjectPlanMetricsList (projectId) {
    return (await this.client.get(PROJECT_PLAN_METRICS_URL.format(projectId))).items;
  }

  async getDashboardAccessTypes () {
    return await this.client.get(
      ACCESS_TYPES_URL
    );
  }

  async getDashboardsList (axiosParams = {}) {
    return (await this.client.get(DASHBOARDS_LIST, {}, {}, axiosParams)).items;
  }

  async getUserDashboardsList (axiosParams = {}) {
    return (await this.client.get(USER_DASHBOARDS_LIST_URL, {}, {}, axiosParams)).items;
  }

  async getDashboard (dashboardId) {
    const dashboardData = (await this.client.get(
      DASHBOARD_DETAILS_URL.format(dashboardId), {}, {}
    )).data;

    /*
     * support lineChart with two metrics
     * change metric on metricsList
     * metricsList must always be an array
     */
    dashboardData.widgets = dashboardData.widgets.map(w => {
      if (w.type === 'lineChart') {
        if (w[`${w.type}Values`].metric) {
          if (typeof w[`${w.type}Values`].metric === 'string') {
            w[`${w.type}Values`].metricsList = [w[`${w.type}Values`].metric];
          } else {
            w[`${w.type}Values`].metricsList = w[`${w.type}Values`].metric;
          }
          delete w[`${w.type}Values`].metric;
        } else if (w[`${w.type}Values`].metricsList) {
          if (typeof w[`${w.type}Values`].metricsList === 'string') {
            w[`${w.type}Values`].metricsList = [w[`${w.type}Values`].metricsList];
          }
        }
      }
      return w;
    });

    return dashboardData;
  }

  async getDashboardPlanMetrics (dashboardId) {
    return (await this.client.get(
      DASHBOARD_PLAN_METRICS_URL.format(dashboardId), {}, {}
    )).items;
  }

  async deleteDashboard (dashboardId) {
    return await this.client.delete(
      DASHBOARD_DETAILS_URL.format(dashboardId)
    );
  }

  async createDashboard (dashboardParams) {
    dashboardParams.widgets = dashboardParams.widgets ? dashboardParams.widgets : [];
    return (await this.client.post(
      CREATE_USER_DASHBOARD_URL,
      dashboardParams
    )).data.data;
  }

  async updateDashboard (dashboardId, dashboardParams) {
    if (dashboardParams.isGlobalDashboard) {
      return await this.client.put(
        DASHBOARD_DETAILS_URL.format(dashboardId),
        dashboardParams
      );
    }

    return await this.client.put(
      PROJECT_DASHBOARD_URL.format(dashboardId),
      {widgets: dashboardParams.widgets}
    );
  }
}
